import React, { useCallback } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { useEditionAwareness } from '../../services/edition-awareness-context';
import { useGetExperimentValue } from '../../services/experiment-context';
import { isEligibleForEAtoOSBPremiumNonRTExperiment } from '../../services/is-eligible-for-ea-to-osb-premium-non-rt-experiment';
import type { LinkConfig } from '../dialogs/shared/types';
import { EditionAwarenessLink } from '../edition-awareness-button';

export const LINK_CONFIG: LinkConfig = {
	linkId: 'payment-flow',
	touchpointIntent: 'addPaymentDetails',
};

interface PaymentFlowLinkProps {
	href: string;
}

const PaymentFlowLinkContent = ({ href }: PaymentFlowLinkProps): React.JSX.Element => {
	const context = useEditionAwareness();
	const { getExperimentValue } = useGetExperimentValue();

	const handlePaymentFlowClick = useCallback(() => {
		// Fire exposure for ea-to-osb-premium-non-rt experiments variation tenants
		if (isEligibleForEAtoOSBPremiumNonRTExperiment(context)) {
			getExperimentValue({
				statsigParams: {
					experimentName: 'ea-to-osb-premium-non-rt-aa',
					parameterName: 'cohort',
					defaultValue: 'not-enrolled',
				},
				trackEventParameters: {
					trackEventGrowthInitiative: 'tako',
				},
			});
			getExperimentValue({
				statsigParams: {
					experimentName: 'ea-to-osb-premium-non-rt-ab',
					parameterName: 'cohort',
					defaultValue: 'not-enrolled',
				},
				trackEventParameters: {
					trackEventGrowthInitiative: 'tako',
				},
			});
		}
	}, [context, getExperimentValue]);

	return (
		<EditionAwarenessLink
			href={href}
			target="_blank"
			onClick={handlePaymentFlowClick}
			{...LINK_CONFIG}
		/>
	);
};

export const PaymentFlowLink = (): React.JSX.Element => {
	const { addPaymentDetailsExperienceUrl } = useEditionAwareness();

	if (addPaymentDetailsExperienceUrl) {
		return (
			<AnalyticsContext data={LINK_CONFIG}>
				<PaymentFlowLinkContent href={addPaymentDetailsExperienceUrl} />
			</AnalyticsContext>
		);
	}
	return <></>;
};
